import { getUserInfo } from '@/api';
//状态，不允许直接对state操作，只能通过mutations或者actions改变
const state = {
    customerList:[],
    adultNum:0
}


//同步方法
const mutations = {
    setCustomerList (state,data) {
        state.customerList = state.customerList.concat(data)
    },
    removeCustomerList(state,idx){
        state.customerList.splice(idx,1)
    },
    updateCustomerList(state,data) {
        let changeCustomerIdx = state.customerList.findIndex(ele => ele.followId == data.followId);
        state.customerList.splice(changeCustomerIdx,1);
        state.customerList = state.customerList.concat(data) 
    },
    resetCustomerList(state){
        state.customerList = [] ;
    }
}

//异步方法
const actions = {
    setCustomerListAction( {commit},data ){
        commit('setCustomerList',data)
    },
    removeCustomerListAction({ commit },idx){
        commit('removeCustomerList',idx)
    },
    updateCustomerListAction({commit},data) {
        commit('setCustomerList',data)
    },
    resetCustomerListAction({commit},data) {
        commit('resetCustomerList')
    }
}
export default{
    namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/orderPlace.js